module.exports = __webpack_public_path__ + "media/video07.f3624b23.mp4";